import { ImageBlock, ImageBlockProps } from '@/components/blocks/ImageBlock/ImageBlock';
import { QuoteContent } from '@/components/blocks/QuoteContent/QuoteContent';
import { CTA, CTAProps } from '@/components/CTA';
import { TestimonialCardProps } from '@/components/TestimonialCard/TestimonialCard';
import classNames from 'classnames';

import React from 'react';
import styles from './SingleTestimonial.module.scss';

export interface SingleTestimonialProps {
  testimonial: TestimonialCardProps;
  cta?: CTAProps;
  image?: ImageBlockProps;
  className?: string;
}

export const SingleTestimonial: React.FC<SingleTestimonialProps> = ({
  testimonial,
  cta,
  image,
  className,
}) => {
  const styleClassNames = classNames(
    styles.single_testimonial_container,
    image ? styles.single_testimonial_with_image : '',
    className,
  );

  return (
    <div className={styleClassNames}>
      <div className={styles.left_container}>
        <QuoteContent
          author={testimonial.author}
          authorAvatarUrl={testimonial.authorAvatarUrl}
          quote={testimonial.quote}
          className={styles.single_testimonial_quote_content}
        />
        {cta && <CTA label={cta.label} link={cta.link} type={cta.type} />}
      </div>
      {image && (
        <ImageBlock
          src={image.src}
          alt={image.alt || 'Single Testimonial'}
          aspectRatio={image.aspectRatio}
          className={styles.module_image}
          responsive={{
            compactWidth: 575,
            desktopWidth: 575,
            sizes: '(max-width: 600px) 100vw, 575px',
          }}
        />
      )}
    </div>
  );
};
